<template>
  <div>
    <SearchBarComponent ref="search"></SearchBarComponent>
    <b-container class="search-results-container">
      <b-row>
        <b-col sm="3">
          <div class="categories">
            <h3>Filter</h3>
            <b-form-checkbox
              plain
              v-for="product in products"
              :key="product.name"
              v-model="filters"
              :name="product.name"
              :value="product.name"
              :disabled="product.amount === 0"
              @change="updateResults"
            >{{product.name}} ({{product.amount}})</b-form-checkbox>
          </div>
        </b-col>
        <b-col sm="6">
          <div class="search-results" v-if="searchResults.length > 0">
            <b-list-group>
              <router-link
                v-for="result in searchResults"
                :key="result.url"
                :to="{path: result.url }"
                class="list-item"
              >
                <b-list-group-item>
                  <span class="product-icon">
                    <img :src="result.productIcon" />
                  </span>
                  <span v-if="result.articleName">
                    <strong>{{result.articleName}}</strong>
                    <br />
                    <span class="small-text">
                      {{result.productName}} {{result.appName == 0 ? '' : '- ' + result.appName}}
                      <span
                        v-if="result.sectionName.length > 0"
                      >- {{result.sectionName}}</span>
                    </span>
                  </span>
                  <span v-else-if="result.sectionName">
                    <strong>{{result.sectionName}}</strong>
                    <br />
                    <span class="small-text">{{result.productName}} {{result.appName == 0 ? '' : '- ' + result.appName}}</span>
                  </span>
                  <span v-else-if="result.appName">
                    <strong>{{result.appName}}</strong>
                    <br />
                    <span class="small-text">{{result.productName}}</span>
                  </span>
                  <span v-else>
                    <strong>{{result.productName}}</strong>
                  </span>
                </b-list-group-item>
              </router-link>
            </b-list-group>
          </div>
          <div v-else>Sorry no results =(</div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import SearchBarComponent from './SearchBarComponent.vue';

export default {
  name: 'Products',
  components: { SearchBarComponent },
  data() {
    return {
      searchResults: [],
      products: [],
      filters: []
    };
  },
  beforeRouteEnter(to, from, next) {
    to;
    axios
      .get(
        process.env.VUE_APP_BASE_URL +
          '/' +
          'search?query=' +
          to.query.query +
          '&limit=-1'
      )
      .then(response => {
        next(vm => {
          vm.setData(to.query.query, response.data);
        });
      });
  },
  beforeRouteUpdate(to, from, next) {
    axios
      .get(
        process.env.VUE_APP_BASE_URL +
          '/' +
          'search?query=' +
          to.query.query +
          '&limit=-1&filter=' +
          this.filters
      )
      .then(response => {
        this.setData(to.query.query, response.data);
        next();
      });
  },
  methods: {
    setData(query, data) {
      this.$refs.search.searchQuery = query;
      this.searchResults = data.results;
      if (data.products) {
        this.products = data.products;
      }
    },
    updateResults() {
      //this.$refs.search.showAllResults();
      setTimeout(() => {
        axios
          .get(
            process.env.VUE_APP_BASE_URL +
              '/' +
              'search?query=' +
              this.$refs.search.searchQuery +
              '&limit=-1&filter=' +
              this.filters
          )
          .then(response => {
            this.searchResults = response.data.results;
          });
      }, 50);
    }
  }
};
</script>

<style scoped>
.search-results-container {
  padding-top: 3rem;
}

.small-text {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  color: rgb(34, 34, 34) !important;
  font-size: 12px !important;
  line-height: 16px !important;
  font-family: Circular, -apple-system, BlinkMacSystemFont, Roboto,
    Helvetica Neue, sans-serif !important;
  font-weight: 400 !important;
}

.product-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

h2 {
  color: white;
  font-size: 56px;
  margin-bottom: 20px;
}

div.search-results {
  position: absolute;
  width: 100%;
  z-index: 1;
}

.list-group {
  margin: auto;
  border: none;
  border-radius: 4px;
  background-color: #fff;
  overflow: hidden;
  text-align: left;
}

.list-group-item {
  padding: 0.55rem 1.25rem;
  padding-left: 42px;
  border-radius: 0px;
  border: none;
  border-top: 1px solid lightgray;
}

a.list-item:last-of-type {
  border-bottom: 1px solid lightgray;
}

.list-group-item:hover {
  outline: none;
}

.categories {
  width: auto;
  display: inline-block;
}

h3 {
  border-bottom: 1px solid lightgray;
}

a {
  color: inherit;
  text-decoration: none;
}

a:hover {
  color: inherit;
  text-decoration: none;
}

.admin-button {
  position: relative;
  z-index: 0;
}

.list-group-item img {
  max-height: 100%;
  width: 22px;
  margin-right: 12px;
}

.search-results-container {
  padding-top: 3rem;
}

@media (max-width: 767px) {
  .search-results-container {
    padding-top: 6px;
  }
  .categories {
    margin-bottom: 10px;
  }
}
</style>
